import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { InputAdornment, /* FormControlLabel, Checkbox*/ } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// import { ReCaptcha } from 'react-recaptcha-google';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ReCAPTCHA from "react-google-recaptcha";
import { VERIFY_CAPTCHA_MESSAGE } from 'src/constants/NotificationMessageConstant';

export default class RegisterComponent extends React.Component<any, any> {
    state = {
        countryIds: [],
        countryId: 0,
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        organization: '',
        isFirstnameValid: true,
        isLastnameValid: true,
        isEmailValid: true,
        isPasswordValid: true,
        isConfirmPasswordValid: true,
        isOrganizationValid: true,
        isFirstnameFormatValid: true,
        isLastnameFormatValid: true,
        isOrganizationFormatValid: true,
        isEmailFormatValid: true,
        isPasswordFormatValid: true,
        isConfirmPasswordFormatValid: true,
        isConfirmPasswordMatch: true,
        successMessage: '',
        showPassword: false,
        isClientCaptchaVerified: false,
        showClientCaptchaNotVerifiedMessage: false,
    };

    constructor(props: any, context: any) {
        super(props, context);

        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.getOrganization = this.getOrganization.bind(this);
        this.getEmail = this.getEmail.bind(this);
        this.getPassword = this.getPassword.bind(this);
        this.getConfirmPassword = this.getConfirmPassword.bind(this);
        this.registerUser = this.registerUser.bind(this);
        this.back = this.back.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.registeredUser && nextProps.registeredUser !== undefined
            && nextProps.registeredUser.success
            && nextProps.registeredUser.payload != null) {
            if (this.state.successMessage !== 'User registered successfully, approval from admin is pending.') {
                this.setState({
                    successMessage: 'User registered successfully, approval from admin is pending.',
                    firstName: '',
                    lastName: '',
                    countryId: '',
                    organization: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                })
            }
        }

        if (nextProps.registeredUser &&
            nextProps.registeredUser.error &&
            nextProps.registeredUser.error.messages) {
            this.setState({
                successMessage: nextProps.registeredUser.error.messages[0],
                firstName: '',
                lastName: '',
                countryId: '',
                organization: '',
                email: '',
                password: '',
                confirmPassword: '',
            });
        }
    }

    componentWillUnmount() {
        this.props.unmountRegister();
    }

    handleClickShowPassword() {
        this.setState({ showPassword: !this.state.showPassword });
    }

    getFirstName = (event: any) => {
        this.setState({ firstName: event.target.value });
    };

    getLastName = (event: any) => {
        this.setState({ lastName: event.target.value });
    };

    getOrganization = (event: any) => {
        this.setState({ organization: event.target.value });
    };

    getEmail = (event: any) => {
        this.setState({ email: event.target.value });
    };

    getPassword = (event: any) => {
        this.setState({ password: event.target.value });
    };

    getConfirmPassword = (event: any) => {
        this.setState({ confirmPassword: event.target.value });
    };

    handleCountryChange = (event: any) => {
        this.setState({ countryId: event.target.value });
        this.setState((prevState: any) => ({
            countryIds: [event.target.value]
        }))
    }

    validateEmail(email: any) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validateTextForScriptTag(text: any) {
        const re = /<script.*?>([\s\S]*?)<\/script>/
        return !re.test(String(text).toLowerCase());
    }

    validateUser() {
        let isDataValid = true;

        this.setState({ successMessage: '' });
        if (this.state.firstName === '') {
            this.setState({ isFirstnameValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isFirstnameValid: true });
        }

        if (!this.validateTextForScriptTag(this.state.firstName)) {
            this.setState({ isFirstnameFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isFirstnameFormatValid: true });
        }

        if (this.state.lastName === '') {
            this.setState({ isLastnameValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isLastnameValid: true });
        }

        if (!this.validateTextForScriptTag(this.state.lastName)) {
            this.setState({ isLastnameFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isLastnameFormatValid: true });
        }

        if (this.state.organization === '') {
            this.setState({ isOrganizationValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isOrganizationValid: true });
        }

        if (!this.validateTextForScriptTag(this.state.organization)) {
            this.setState({ isOrganizationFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isOrganizationFormatValid: true });
        }

        if (this.state.email === '') {
            this.setState({ isEmailValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isEmailValid: true });
        }

        if (!this.validateEmail(this.state.email)) {
            this.setState({ isEmailFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isEmailFormatValid: true });
        }

        if (this.state.password === '') {
            this.setState({ isPasswordValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isPasswordValid: true });
        }

        if (!this.validateTextForScriptTag(this.state.password)) {
            this.setState({ isPasswordFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isPasswordFormatValid: true });
        }

        if (this.state.confirmPassword === '') {
            this.setState({ isConfirmPasswordValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isConfirmPasswordValid: true });
        }

        if (this.state.confirmPassword !== this.state.password) {
            this.setState({ isConfirmPasswordMatch: false });
            isDataValid = false;
        }
        else {
            this.setState({ isConfirmPasswordMatch: true });
        }

        if (!this.validateTextForScriptTag(this.state.confirmPassword)) {
            this.setState({ isConfirmPasswordFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isConfirmPasswordFormatValid: true });
        }

        // If we hide captcha code then comment below code
        /* TODO - uncomment to enable captcha  */
        if (this.state.isClientCaptchaVerified && this.props.isCaptchaVerified) {
            this.setState({ showClientCaptchaNotVerifiedMessage: false });
        }
        else {
            this.setState({ showClientCaptchaNotVerifiedMessage: true });
            isDataValid = false;
        }
       
        return isDataValid;
    }

    registerUser = (evt: any) => {
        if (this.validateUser()) {
            this.setState({ successMessage: '' });
            const userData = {
                userCountryId: this.state.countryId,
                countryIds: this.state.countryIds,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                password: this.state.password,
                confirmPassword: this.state.confirmPassword,
                activeCountryId: this.state.countryId,
                organization: this.state.organization,
                // isDataUser: this.state.isDataUser
            }

            this.props.registerUser(userData);
        }
        evt.preventDefault()
    };

    back() {
        this.props.redirect('/login');
    }

    onCaptchaChange(value: any) {
        if (value) {
            this.setState({ showClientCaptchaNotVerifiedMessage: false });
            this.setState ({ isClientCaptchaVerified : true });
            this.props.verifyCaptcha(value);
        }
        else {
            this.setState ({ isClientCaptchaVerified : false });
        }      
    }

    render() {
        return (
            <>
                <div className="loginTitleSection">
                    <IconButton onClick={this.back} className="backButton" color="inherit" aria-label="Open drawer">
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Typography component="h4" variant="title" align="center" gutterBottom={true} className="registerTitle">
                        Register
                    </Typography>
                </div>

                <form className="registerForm" autoComplete="off">
                    {
                        this.state.successMessage !== '' &&
                            this.state.successMessage === 'User registered successfully, approval from admin is pending.' ?
                            <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                                <div className='successMessage'>{this.state.successMessage}</div>
                            </FormControl>
                            :
                            <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                                <div className='errorMessage'>{this.state.successMessage}</div>
                            </FormControl>
                    }
                    <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                        <InputLabel htmlFor="firstName">First Name</InputLabel>
                        <Input className="inputControl" id="firstName" name="firstName" autoComplete="firstName" autoFocus={true} onChange={this.getFirstName} value={this.state.firstName} />
                        {!this.state.isFirstnameValid && <span className="errorMessage">First Name can't be empty.</span>}
                        {this.state.isFirstnameValid && !this.state.isFirstnameFormatValid && <span className="errorMessage">Invalid First Name.</span>}
                    </FormControl>
                    <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                        <InputLabel htmlFor="lastName">Last Name</InputLabel>
                        <Input className="inputControl" id="lastName" name="lastName" autoComplete="lastName" autoFocus={false} onChange={this.getLastName} value={this.state.lastName} />
                        {!this.state.isLastnameValid && <span className="errorMessage">Last Name can't be empty.</span>}
                        {this.state.isLastnameValid && !this.state.isLastnameFormatValid && <span className="errorMessage">Invalid Last Name.</span>}
                    </FormControl>
                    <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                        <InputLabel htmlFor="organization">Organization</InputLabel>
                        <Input className="inputControl" id="organization" name="organization" autoComplete="organization" onChange={this.getOrganization} value={this.state.organization} />
                        {!this.state.isOrganizationValid && <span className="errorMessage">Organization can't be empty.</span>}
                        {!this.state.isOrganizationFormatValid && <span className="errorMessage">Invalid Organization.</span>}
                    </FormControl>
                    <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                        <InputLabel htmlFor="email">Email Address</InputLabel>
                        <Input className="inputControl" id="email" name="email" autoComplete="email" autoFocus={false} onChange={this.getEmail} value={this.state.email} />
                        {!this.state.isEmailValid && <span className="errorMessage">Email can't be empty.</span>}
                        {this.state.isEmailValid && !this.state.isEmailFormatValid && <span className="errorMessage">Invalid Email.</span>}
                    </FormControl>
                    <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <Input
                            className="inputControl"
                            name="password"
                            type={this.state.showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="current-password"
                            onChange={this.getPassword}
                            value={this.state.password}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowPassword}>
                                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        {!this.state.isPasswordValid && <span className="errorMessage">Password can't be empty.</span>}
                        {this.state.isPasswordValid && !this.state.isPasswordFormatValid && <span className="errorMessage">Invalid Password.</span>}
                    </FormControl>
                    <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                        <InputLabel htmlFor="password"> Confirm Password</InputLabel>
                        <Input className="inputControl" name="confirmPassword" type="password" id="confirmPassword" autoComplete="current-password" onChange={this.getConfirmPassword} value={this.state.confirmPassword} />
                        {!this.state.isConfirmPasswordValid && <span className="errorMessage">Confirm Password can't be empty.</span>}
                        {this.state.isConfirmPasswordValid && !this.state.isConfirmPasswordMatch && <span className="errorMessage">Confirm Password doesnot match.</span>}
                        {this.state.isConfirmPasswordValid && !this.state.isConfirmPasswordFormatValid && <span className="errorMessage">Invalid Confirm Password.</span>}
                    </FormControl>
                    {/*
                     * 
                     *   // TODO - uncomment to disable captcha
                     *   */
                    <div className="captcha-wrapper">
                        <ReCAPTCHA
                            sitekey={this.props.appSettings && this.props.appSettings.googleCaptchaSitetKey}
                            onChange={this.onCaptchaChange}
                        />
                        {this.state.showClientCaptchaNotVerifiedMessage && <span className="errorMessage">{VERIFY_CAPTCHA_MESSAGE}</span>}
                    </div>  
                  }
                    <Button
                        type="submit"
                        fullWidth={true}
                        variant="contained"
                        color="primary"
                        className="registerBtn"
                        onClick={this.registerUser}
                    >
                        Register <ChevronRightIcon className="ChevronRightIcon" />
                    </Button>
                </form>

            </>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/register/index.tsx